import React from 'react';

const headingSizes = {
  1: 'text-3xl font-extrabold',
  2: 'text-2xl font-bold',
  3: 'text-xl font-semibold',
};

const PlaybookHeading = ({ level = 2, children, className = '' }) => {
  const Tag = `h${level}`;
  return (
    <Tag className={`${headingSizes[level] || headingSizes[2]} text-white tracking-tight ${className}`}>
      {children}
    </Tag>
  );
};

export default PlaybookHeading; 